/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { FC, memo } from 'react';
import './Error.css';

interface ErrorProps {
    error: MediaError | null;
}

const Error: FC<ErrorProps> = ({ error }) => {
    const refreshHandler = () => {
        window.location.reload();
    };

    return error ? (
        <div className="vp-error">
            <p>
                {error.code ? `${error.code}: ` : ''}
                {error.message || 'Error occurred! Please try again'}
            </p>
            <button onClick={refreshHandler}>ReloadIcon</button>
        </div>
    ) : null;
};

export default memo(Error);
